import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export type StatusBadgeType = 'success' | 'pending' | 'error' | 'inactive' | 'warning';

@Component({
  selector: 'xemex-status-chip',
  standalone: true,
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './status-chip.component.scss',
  template: `
    <span class="chip" [attr.data-status]="status()" [attr.data-size]="size()">
      @if (dot()) {
        <span class="chip__dot"></span>
      } @else if (icon()) {
        <mat-icon class="chip__icon">{{ icon() }}</mat-icon>
      }
      <span class="chip__label">{{ label() }}</span>
    </span>
  `,
})
export class StatusChipComponent {
  status = input.required<StatusBadgeType>();
  label = input.required<string>();
  icon = input<string>();
  /** Show a filled dot in the status colour instead of an icon. Takes precedence over `icon()`.
   * `booleanAttribute` so the bare `dot` attribute works rather than passing a falsy empty string. */
  dot = input(false, { transform: booleanAttribute });
  /** `sm` (default) is the original compact chip; `lg` is used where the badge needs to stand out more, e.g. the device detail page header. */
  size = input<'sm' | 'lg'>('sm');
}
